export default {
  'label.progress.finished': 'Finished',
  'label.progress.inprogress': 'In progress',
  'panel.title': 'Check',
  'panel.submissionDate': 'Date of submission',
  'panel.amount': 'Amount',
  'cheque.type.person': 'Person',
  'cheque.type.company': 'Company',
};
